import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { LastTurnedRollRow } from "../models/LastTurnedRolls";

export interface GetLastTurnedRollsParams {
	start: string;
	end: string;
	signal?: AbortSignal;
}

export const getLastTurnedRollsData = async ({
	start,
	end,
	signal,
}: GetLastTurnedRollsParams): Promise<LastTurnedRollRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
		{ name: "timeZoneCode", value: null },
		{ name: "fromRow", value: 0 },
		{ name: "toRow", value: null },
		{ name: "rowsToFetch", value: 100000 },
		{ name: "sortType", value: null },
		// BIT param: the API rejects numbers, must be a JS boolean. The grid does
		// its own Excel export, so we never need the SP's FixedComments column.
		{ name: "isExporting", value: false },
	];

	const spName = "[ROLLS].[GetLastTurnedRollsDataWeb]";
	const resp = await apiService.callV2(spName, parameters, signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching last turned rolls");
	}
	return get(resp, "data.tables[0].rows", []) as LastTurnedRollRow[];
};
